import { useContext } from 'react';
import { FormContext } from '../../context/CreatePersonaFormContext';

/**
 * Typed form context hook for the CreatePersonaForm.
 * Returns the full extended form return including config properties.
 */
export function useCreatePersonaFormContext() {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useCreatePersonaFormContext must be used within CreatePersonaFormProvider');
  }
  return context;
}
